<!-- src/views/DashboardView.vue -->

<template>
  <div class="row">
    <div class="col-md-12">
      <div ref="carousel" class="carousel">
        <div
          v-for="banner in banners"
          :key="banner.id"
          class="carousel-cell"
          @click="navigateBanner(banner)"
        >
          <img :src="banner.image_url" class="banner-img" />
        </div>
      </div>
    </div>
  </div>
  <br />
</template>

<script>
import Flickity from "flickity";
import "flickity/css/flickity.css";
import { apiUrl } from "@/utils/api";

export default {
  name: "bannersHome",
  data() {
    return {
      banners: [],
    };
  },
  async mounted() {
    await this.fetchBanners();

    this.$nextTick(() => {
      const carouselElement = this.$refs.carousel;
      if (carouselElement) {
        new Flickity(carouselElement, {
          contain: true,
          autoPlay: true,
          wrapAround: true,
          cellAlign: "left",
        });
      }
    });
  },
  methods: {
    async fetchBanners() {
      try {
        const response = await fetch(`${apiUrl}/home/web`);
        const jsonResponse = await response.json();
        this.banners = jsonResponse.banners;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    navigateBanner(banner) {
      switch (banner.type) {
        case "course":
          // مثال
          window.open(`/course-details?id=${banner.type_id}`, "_blank");
          break;

        case "bundle":
          window.open(`/bundle-details?id=${banner.type_id}`, "_blank");
          break;

        case "instructor":
          window.open(`/instructor-profile?id=${banner.type_id}`, "_blank");
          break;

        case "external":
          window.open(banner.external_url, "_blank");
          break;
      }
    },
  },
};
</script>
<style scoped>
/* ========== Animations ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ========== Row Container ========== */
.row {
  animation: fadeIn 0.6s ease forwards;
}

/* ========== Carousel Container ========== */
.carousel {
  height: 350px;
}

/* ========== Carousel Cells ========== */
.carousel-cell {
  width: calc(100% - 10px);
  margin-right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

@media (min-width: 992px) {
  .carousel-cell {
    width: calc(50% - 10px);
    margin-right: 10px;
    height: 100%;
  }
}

/* ========== Banner Image ========== */
.banner-img {
  width: 95%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
  border: 2px solid transparent;
}

.carousel-cell:hover .banner-img {
  transform: scale(1.02);
  box-shadow: 0 15px 40px rgba(0, 196, 68, 0.18);
  border-color: rgba(0, 196, 68, 0.25);
}

/* ========== Flickity Customization ========== */
:deep(.flickity-page-dots) {
  bottom: 0px;
}

:deep(.flickity-page-dots .dot) {
  width: 10px;
  height: 10px;
  background: rgba(0, 196, 68, 0.3);
  opacity: 1;
  transition: all 0.3s ease;
  margin: 0 5px;
}

:deep(.flickity-page-dots .dot.is-selected) {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  width: 24px;
  border-radius: 5px;
}

:deep(.flickity-prev-next-button) {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.3);
  transition: all 0.3s ease;
}

:deep(.flickity-prev-next-button:hover) {
  background: linear-gradient(135deg, #00d44a 0%, #00b844 100%);
  transform: scale(1.08);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.4);
}

:deep(.flickity-prev-next-button .flickity-button-icon) {
  fill: #fff;
}

:deep(.flickity-prev-next-button.previous) {
  left: 15px;
}

:deep(.flickity-prev-next-button.next) {
  right: 15px;
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .banner-img,
[data-theme="dark"] .banner-img,
.dark .banner-img {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);
}

[data-bs-theme="dark"] .carousel-cell:hover .banner-img,
[data-theme="dark"] .carousel-cell:hover .banner-img,
.dark .carousel-cell:hover .banner-img {
  box-shadow: 0 15px 40px rgba(0, 196, 68, 0.2);
  border-color: rgba(0, 196, 68, 0.35);
}

[data-bs-theme="dark"] :deep(.flickity-page-dots .dot),
[data-theme="dark"] :deep(.flickity-page-dots .dot),
.dark :deep(.flickity-page-dots .dot) {
  background: rgba(0, 196, 68, 0.4);
}
</style>
